// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"94a60932","453":"8cc0e317","884":"4b9d455c"}[chunkId] + ".chunk.js";
};